import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import TranslationNS from '@/utils/Constants/TranslationNS'
import { useAuth } from '@/middlewares/auth/auth-context'
import InviteAccessDialog from './InviteAccessDialog'
import { INVITE_ROLES } from './inviteAccess.roles'

/**
 * The side-menu row of an `{ invite }` entry (mock `mnInviteJudge` / `mnInviteCheckin` /
 * `mnInviteMedia`): an <a> like the sibling Link rows, opening the invite dialog. `setCompetition`
 * is the shell's functional patch of the /event/menu summary.
 */
export default function InviteAccessMenuRow({ type, competition, setCompetition, className, style }) {
    const { t } = useTranslation(TranslationNS.CHECKIN)
    const authContext = useAuth()
    const [open, setOpen] = useState(false)
    const role = INVITE_ROLES[type]

    if (!role || !authContext.isAdminOrOrga) return null

    return (
        <>
            <a role="button" className={className} style={style} onClick={() => setOpen(true)}>
                {t(role.title)}
            </a>
            {open && (
                <InviteAccessDialog
                    role={role}
                    competition={competition}
                    onChange={(listProp, updater) =>
                        setCompetition((previous) => ({ ...previous, [listProp]: updater(previous?.[listProp]) }))
                    }
                    onClose={() => setOpen(false)}
                />
            )}
        </>
    )
}
